RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const CompanyCell = widgets.CompanyCell = Marionette.ItemView.extend({
        tagName: 'td',
        template: '#socialPostsCompanyExpansionCellTemplate',
        className: 'company-cell',
        serializeData: function () {
            const me = this;
            const data = me.getOption('data');
            // NOTE company id is always the second dimension value
            const companyId = Number(data[1]);
            const company = RivalIQ.state.landscape.get('companies').get(companyId);

            return _.extend(company.toJSON(), {
                isFocus: companyId === RivalIQ.state.utils.getFocusedCompanyId(),
                presence_icon_url: company.getIcon(),
                companyAbbr: RivalIQ.utils.companyDisplay.getAbbreviation(company.attributes)
            });
        }
    });

    const TextInsight = RivalIQ.views.ItemView.mixin({
        template: '#socialPostsInsightsTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            insight: '.x-insight',
            topicLink: '.topic-link'
        },

        events: {
            'click @ui.topicLink': 'onTopicClick'
        },

        loadData: function () {
            const me = this;

            const definition = me.getOption('metric');

            // NOTE: this metric will request data for all companies, not just the focus company;
            // we'll filter out the other companies later. If we were to specify companyId here, we'd
            // pass that down to the server for filtering there. It's a better use of the cacheLayer
            // to do the filtering ourselves as it saves an XHR to the server.
            const focusDef = definition.build({
                property: 'count',
                aggregate: undefined,
                dimensions: ['companyId']
            });
            const mostEngagingDef = definition.build({
                property: 'avg_engagement_rate_per_post',
                aggregate: undefined
            });

            const postIdsDef = definition.build({
                property: 'postId',
                aggregate: undefined,
                dimensions: ['postId']
            });

            return $.when(definition.fetch(), focusDef.fetch(), mostEngagingDef.fetch(), postIdsDef.fetch()).done(function (landscape, focus, mostEngaging, postIds) {
                me.landscapeTopics = landscape;
                me.focusTopics = focus;
                me.mostEngaging = mostEngaging;

                const keywordPostIds = postIds.getValue({
                    format: false
                });
                me.postIdsByKeyword = _(keywordPostIds)
                    .groupBy(_.first)
                    .mapValues(keywordResult => _.map(keywordResult, _.last))
                    .value();
            });
        },

        onRenderLoaded: function () {
            const me = this;

            me.ui.insight.html(me.getTextInsight());
        },

        getTextInsight: function () {
            const me = this;

            let landscapeTopics = me.landscapeTopics.getValue({
                format: false
            });
            const engagementTopics = me.mostEngaging.getValue({
                format: false
            });
            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';

            if (!landscapeTopics.length) {
                me.ui.insight.addClass('x-no-data');
                return `No Popular Topics found in this set of ${postWord}s.`;
            } else {
                me.ui.insight.removeClass('x-no-data');
            }

            // construct something more friendly to multiple sorts
            const topics = _.map(landscapeTopics, function (topic) {
                const topicName = topic[0];
                const count = topic[1];
                const avgEngagementRate = _.last(_.find(engagementTopics, function (focusTopic) {
                    return focusTopic[0].toLowerCase() === topicName.toLowerCase();
                }));
                return [topicName, count, avgEngagementRate];
            });

            // the table's secondary sort should be applied here as well
            landscapeTopics = _.orderBy(topics, [1, 2], ['desc', 'desc']);

            // Cached topics results can be larger than the number displayed
            // in the table. Trim insight to table size
            const limit = me.getOption('limit');
            landscapeTopics = _.take(landscapeTopics, limit);

            // we should (try to) get the most engaging topic within the set we display.
            // note that this isn't perfect; many topics with the same avg engagement rates
            // may mean that the set we're providing insight for isn't exactly the set the table displays.
            const mostEngaging = _.reduce(landscapeTopics, function (best, topic) {
                if (!best || topic[2] > best[2]) {
                    return topic;
                }
                return best;
            });
            const mostEngagingTopic = mostEngaging[0];
            const focusCompanyId = RivalIQ.state.utils.getFocusedCompanyId();
            const focusTopics = _(me.focusTopics.getValue({
                format: false
            }))
                .filter(function (data) {
                    const companyId = Number(data[1]);
                    return companyId === focusCompanyId;
                })
                .filter(function (data) {
                    return !_.isUndefined(_.last(data)) && _.find(landscapeTopics, function (datum) {
                        return datum[0].toLowerCase() === data[0].toLowerCase();
                    });
                })
                .value();

            const isFiltered = App.utils.arePostsFiltered(me.getOption('dashboardModel'));

            const usedTop = _.find(focusTopics, function (data) {
                return _.head(data).toLowerCase() === mostEngagingTopic.toLowerCase();
            });

            if (landscapeTopics.length === 1) {
                if (usedTop) {
                    return `You are using the only Popular Topic in this set of ${postWord}s.`;
                }

                return `You have not used the only Popular Topic in this set of ${postWord}s.`;
            }

            if (_.last(mostEngaging) === 0) {
                if (isFiltered) {
                    return `Among ${postWord}s matching your query, Popular Topics didn't generate any engagement during this time period.`;
                } else {
                    return `Popular Topics didn't generate any engagement during this time period.`;
                }
            }

            const postIds = me.postIdsByKeyword[mostEngagingTopic];
            const mostEngagingLink =
                $.tagHtml('span', {
                    'data-post-ids': postIds.join(','),
                    class: 'topic-link',
                    text: mostEngagingTopic
                });

            const strong = function (txt) {
                return $.tagHtml('strong', {
                    text: txt
                });
            };

            const insight = [];

            if (isFiltered) {
                insight.push(`Among ${postWord}s matching your query,`);
            } else {
                insight.push('Of the', strong(landscapeTopics.length), 'most broadly used Popular Topics,');
            }

            insight.push(`${postWord}s that included`, mostEngagingLink, `generated the highest Engagement Rate by ${audienceName}.`);

            if (!focusTopics.length) {
                insight.push(`You didn't use any of these Popular Topics.`);
            } else {
                insight.push('You used', strong(focusTopics.length), 'of these', strong(landscapeTopics.length), 'Popular Topics,');

                if (usedTop) {
                    insight.push('including ', `${mostEngagingLink}. Good work!`);
                } else {
                    insight.push(`but you didn't use`, `${mostEngagingLink}.`);
                }
            }

            return insight.join(' ');
        },

        onTopicClick: function (e) {
            const me = this;

            const target = $(e.target);
            const postIds = target.data('post-ids');
            const topic = target.text();

            const props = me.getProps();
            props.forName = topic;
            props.postIds = postIds?.split(',') || [];

            const source = RivalIQ.data.channels.get(props.channel).get('channel');
            RivalIQ.apps.SocialPosts.views.PostsModal.show(props, source);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsViewPostsModal, _.extend({
                widgetId: me.dashboardModel.widgetId
            }, props));
        }
    });

    const KeywordsTable = App.widgets.PostAggregatesTableView.mixin({
        mixins: {
            PostTagsReload: App.mixins.PostTagsReload,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        template: '#keywordUsageTableTemplate',

        className: function () {
            const me = this;
            const observationsClass = !me.getProp('showObservation') ? 'hide-observations' : '';
            return `${App.widgets.PostAggregatesTableView.prototype.className.call(me)} ${observationsClass}`;
        },

        emptyView: Marionette.ItemView.extend({
            template: '#socialPostsKeywordsNoResultsTemplate'
        }),

        regions: {
            insight: '.x-insight-region'
        },

        getPostsModalProps: function (data, dimensionRow) {
            const me = this;

            const props = App.widgets.PostAggregatesTableView.prototype.getPostsModalProps.apply(me, arguments);

            // add in subordinate row info if present.
            if (dimensionRow) {

                // NOTE company id is always the second dimension value
                const companyId = Number(_.head(dimensionRow)[1]);
                const keyword = _.head(dimensionRow)[0];
                props.companyIds = [companyId];

                // This should match the construction of postIdsByKeywordAndCompanyId keys in loadData.
                props.postIds = me.postIdsByKeywordAndCompanyId[`${keyword}-${companyId}`];
            } else {
                props.postIds = me.postIdsByKeyword[data[0][0]];
            }

            return props;
        },

        loadData: function () {
            const me = this;

            const parentLoad = RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.loadData.apply(me, arguments);

            let orderBy = me.getProp('orderBy');
            if (_.isArray(orderBy)) {
                orderBy = orderBy[0];
            }
            let definition = me.dashboardModel.metricsCollection.at(orderBy);
            definition = definition.build({
                orderBy: definition.serialize()
            });

            // These two additional metrics are necessary to get the mapping from keyword to postIds (which we use to pop
            // the posts modal). These metrics load the postIds (the id of each post in ES) for each keyword and each
            // <keyword, companyId> pair.
            const postIdsDef = definition.build({
                property: 'postId',
                aggregate: undefined,
                dimensions: ['postId']
            });

            const companyPostIdsDef = definition.build({
                property: 'postId',
                aggregate: undefined,
                dimensions: ['companyId', 'postId']
            });

            return $.when(
                postIdsDef.fetch(),
                companyPostIdsDef.fetch(),
                parentLoad
            ).then(function (postIds, companyPostIds) {
                const keywordPostIds = postIds.getValue({
                    format: false
                });
                me.postIdsByKeyword = _(keywordPostIds)
                    .groupBy(_.first)
                    .mapValues(keywordResult => _.map(keywordResult, _.last))
                    .value();

                const keywordCompanyPostIds = companyPostIds.getValue({
                    format: false
                });
                me.postIdsByKeywordAndCompanyId = _(keywordCompanyPostIds)
                    // This key construction must match what's in getPostsModalProps.
                    .groupBy(keywordCompanyPostId => `${keywordCompanyPostId[0]}-${keywordCompanyPostId[1]}`)
                    .mapValues(keywordResult => _.map(keywordResult, _.last))
                    .value();
            });
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            me.showTextInsight();
        },

        showTextInsight: function () {
            const me = this;

            if (!me.getProp('showObservation')) {
                return;
            }

            // The text insight widget should always sort by company count.
            let definition = me.dashboardModel.metricsCollection.at(1);
            definition = definition.build({
                orderBy: definition.serialize(),
                sortOrder: 1
            });

            me.insight.show(new TextInsight({
                dashboardModel: me.dashboardModel,
                searchTerm: me.getProp('searchTerm'),
                limit: me.getProp('limit'),
                metric: definition
            }));
        }
    });

    const FooterView = RivalIQ.apps.Dashboard.views.PanelFooter.extend({
        template: '#socialPostsKeywordsFooterTemplate',
        className: 'panel-footer'
    });

    const DetailPanelView = RivalIQ.apps.Dashboard.views.Panel.extend({

        showActions: function () {
            const me = this;

            if (me.dashboardModel.isFocus()) {
                me.actions.show(new RivalIQ.views.ShowSummaryRowSwitch({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });

                const MinimumCompaniesDropdown = App.utils.createNumericFilterDropdown({
                    label: 'Min. Companies',
                    prop: 'keywordsMinCompanies',
                    propDefaultValue: 1,
                    min: 1,
                    max: 10
                });

                me.actions.show(new MinimumCompaniesDropdown({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });

                const postWord = `${_.upperFirst(RivalIQ.data.channels.get(me.getProp('channel')).get('postName'))}s`;

                const MinimumPostsDropdown = App.utils.createNumericFilterDropdown({
                    label: `Min. ${postWord}`,
                    prop: 'keywordsMinPosts',
                    propDefaultValue: 3,
                    min: 1,
                    max: 10
                });

                me.actions.show(new MinimumPostsDropdown({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });
            }

            if (!me.dashboardModel.isFocus()) {
                me.showExportDropdown();
            }
        }
    });

    function normalizeMetricColumns(props) {
        const me = this;

        const keywords = {
            property: 'keyword',
            dimensionView: CompanyCell,
            valueFormat: function (value) {
                const keyword = _.last(value);

                if (keyword === '__SUMMARY_ROW__') {
                    const postWord = RivalIQ.data.channels.get(props.channel).get('postName');
                    return Marionette.TemplateCache.get('#allPostsRowCellTemplate')({
                        postWord
                    });
                }

                return keyword;
            }
        };

        const companiesUsing = {
            property: 'companies_using'
        };

        const postsAbout = {
            property: 'posts_about'
        };

        const engTotalPerPost = {
            property: 'engagement_total_per_post',
            description: RivalIQ.strings.social_posts_popular_topics_engagement_total_per_post_description
        };

        const postWord = RivalIQ.data.channels.get(props.channel).get('postName');
        const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';

        const avgEngTotalPerPost = {
            property: 'avg_engagement_rate_per_post',
            cellView: _.constant(RivalIQ.views.metric.Bar.extend({
                color: RivalIQ.enums.colors.competitor
            })),
            description: RivalIQ.str('social_posts_engagement_rate_by_follower', postWord, audienceName.toLocaleLowerCase(), audienceName)
        };

        const engRateLift = {
            property: 'engagement_rate_by_presence_reach_lift'
        };

        if (!me.isFocus()) {
            me.metrics = [keywords, companiesUsing, postsAbout, avgEngTotalPerPost];
        } else {
            me.metrics = [keywords, companiesUsing, postsAbout, engTotalPerPost, avgEngTotalPerPost, engRateLift];
        }

        if (_.includes([RivalIQ.enums.channels.YOUTUBE, RivalIQ.enums.channels.TIKTOK], props.channel)) {
            me.metrics.push({
                property: 'views'
            });
        } else if (_.isUndefined(props.channel) && me.isFocus()) { // cross-channel
            me.metrics.push({
                property: 'views'
            });
        }

        me.metricsCollection = me.metrics;
        RivalIQ.models.MetricDefinition.build(me, me.metric, {}, 'metricsCollection');

        _.defaults(props, {
            metrics: me.metrics
        });
    }

    const KeywordsWidget = widgets.PostDimensionTable.extend({

        title: 'Popular Topics',
        description: function () {
            const me = this;

            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            const descTemplate = (!me.isFocus() ? 'social_posts_keywords_info_summary' : 'social_posts_keywords_info_details');
            return RivalIQ.str(descTemplate, postWord, postWord);
        },

        footerView: FooterView,
        hasFooter: _.constant(true),
        detailPanelView: DetailPanelView,
        expansionTracking: RivalIQ.tracking.metric.SocialPostsExpandedTableRow,

        propsToSerializeForExport: [
            'metrics',
            'keywordsMinCompanies',
            'keywordsMinPosts'
        ].concat(App.utils.widgetExportProps),

        getView: function () {
            return KeywordsTable;
        },

        viewMorePath: function () {
            const me = this;
            return me.getPath({
                limit: -1
            });
        },

        getBaseMetric: function () {
            return new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POST.id,
                dimensions: ['keyword'],
                keywordsOnly: true
            });
        },

        normalizeMetricColumns: normalizeMetricColumns,

        processProps: function (props) {
            const me = this;

            // NOTE these defaults should match the server sort defaults
            const defaultOrderBy = [1, 2, 3];

            // NOTE if you sort by companies using, go back to the default sort
            if (props.orderBy === 1) {
                props.orderBy = defaultOrderBy;
            }

            _.defaults(props, {
                orderBy: defaultOrderBy,
                sortOrder: 1,
                showDescriptions: true
            });

            if (!me.isFocus()) {
                props.includeSummaryRow = false;
                props.showObservation = true;
            }

            props = widgets.PostDimensionTable.prototype.processProps.apply(me, arguments);

            return props;
        },

        csvExportProps: function () {
            const me = this;

            return {
                type: 'keywords',
                metric: me.metric.build({
                    limit: -1
                }).serialize()
            };
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_KEYWORDS_TABLE, KeywordsWidget);

});
